import React from 'react'
import { accentUtils } from '../../services/HelperService'
import { AccentHtmlBasicUnbound } from '../unbound/AccentHtmlBasicUnbound'

/// Bound wrapper for AccentHtmlBasicUnbound — basic HTML (b/i/u/s/sub/sup/br) matching the
/// markup DevExpress report text controls support. Used via AccentFormCtrl type "htmlBasic".
export class AccentHtmlBasic extends React.Component {

    constructor(props) {
        super(props);

        this.currentUserValue = this.props.model.getValue();
        this.editorKey = 1;

        this.onChange = this.onChange.bind(this);
    }

    onChange(value) {

        this.currentUserValue = value;

        this.props.model.setValue(value);
        this.props.model.modified();

        if (!accentUtils.isNull(this.props.model.options.onChange)) {
            this.props.model.options.onChange({ value: value });
        }
    }

    render() {

        let modelValue = this.props.model.getValue();

        if (modelValue !== this.currentUserValue) {
            // Model changed externally — remount the editor so defaultContent picks it up.
            this.currentUserValue = modelValue;
            this.editorKey++;
        }

        if (accentUtils.isNull(modelValue)) {
            modelValue = '';
        }

        return (
            <AccentHtmlBasicUnbound
                key={this.editorKey}
                defaultValue={modelValue}
                onChange={this.onChange}
                required={this.props.model.required}
                height={this.props.model.options.height}
                dataTagName={this.props.model.field?.fieldName}
            />
        );
    }
}
